import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IUserAccountDto } from '@my-aon/auth';
import { SharedModule } from '@my-aon/shared';
import { FormAccountDetailsComponent } from '../../components/form-account-details/form-account-details.component';

@Component({
    selector: 'lib-dialog-account-details',
    templateUrl: './dialog-account-details.component.html',
    styleUrl: './dialog-account-details.component.scss',
    standalone: true,
    imports: [SharedModule, FormAccountDetailsComponent],
})
export class DialogAccountDetailsComponent {
    readonly dialogRef =
        inject<MatDialogRef<DialogAccountDetailsComponent>>(MatDialogRef);
    readonly data = inject<{ data: IUserAccountDto }>(MAT_DIALOG_DATA);

    readOnly = true;

    submited: boolean = false;

    close = (e: IUserAccountDto | undefined): void => {
        this.dialogRef.close(e);
    };

    onSubmit = (e?: any): void => {
        if (this.submited === false) this.submited = true;
    };
}
